import { Outlet } from "react-router-dom";
import { Fragment } from "react/jsx-runtime";
import useGetFormQueryByParam from "../../hooks/useGetFormQueryByParam";

function FormRouteIdentifier() {
  useGetFormQueryByParam({
    refetchOnMountOrArgChange: true
  })

  return (
    <Fragment>
      <Fragment>
        <Outlet />
      </Fragment>
    </Fragment>
  );
}

export default FormRouteIdentifier;
